import { gql } from '@apollo/client'

export const GET_GLOBAL_FEEDS_BY_CAMPAIGN_ID = gql`
  query ($campaignId: String!, $offset: Int, $limit: Int, $includePeakStories: Boolean = false,$filter: [FeedTagFilter], $isPreview: Boolean = false) {
    getFeedsByCampaignId(campaignId: $campaignId, offset: $offset, limit: $limit, includePeakStories: $includePeakStories,filter: $filter, isPreview: $isPreview) {
      feeds {
        shared_from {
          label_id
        }
        editable
        gallery
        id
        body
        title
        argument_type
        created_at
        updated_at
        properties
        product_id
        campaign_id
        global_status
        review_status
        pinned
        pinned_by
        pinned_at
        tags {
          id
          label
          order_number
        }
        lastEditor {
          last_name
          first_name
          email
        }
        comments {
          id
          text
          updated_at
          campaign_id
          author {
            first_name
            last_name
            label_id
          }
        }
        author {
          last_name
          first_name
          email
        }
        product {
          name
          configuration
          parent_id
        }
        facts {
          chart
          position_current_at
        }
        campaign {
          id
          name
          owner_id
          label_id
        }
        artist {
          name
          spotify_id
          facebook_id
        }
      }
      total
    }
  }
`
